export const shadows = {
  bold: '0 2px 8px 0 rgba(0, 0, 0, 0.4), 1px 0 0 0 #e1e6ec',
}
